module.exports = __webpack_public_path__ + "img/pedestrian.30731779.svg";